import { confirm } from 'devextreme/ui/dialog';

export type ConfirmDialog = (
  text: string,
  confirmCb: () => void,
  cancelCb?: () => void,
  title?: string
) => void;

export const confirmDialog: ConfirmDialog = (
  text,
  confirmCb,
  cancelCb,
  title
) => {
  const confirmation = confirm(text, title || '');

  confirmation.then((res) => {
    if (res) {
      confirmCb();
    } else if (cancelCb) {
      cancelCb();
    }
  });
};
